import ChartApi from '../../pages/rol-medios-democracias/ChartApi';

export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            <ChartApi />
          </div>
        </div>
      </div>
    </div>
  )
}